import * as React from 'react';
import type { SVGProps } from 'react';
const SvgParsingSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M9.855 4.832H3.5a.75.75 0 0 1 0-1.5h6.355a2 2 0 0 1 3.709 0H16.5a.75.75 0 0 1 0 1.5h-2.936a2 2 0 0 1-3.71 0Zm.854-.75a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.116 7.916a2 2 0 0 0-1.854 1.25H3.5a.75.75 0 1 0 0 1.5h1.762a2 2 0 0 0 3.71 0H16.5a.75.75 0 0 0 0-1.5H8.971a2 2 0 0 0-1.855-1.25m-1 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5.71 5.083a2 2 0 0 1 3.71 0h.964a.75.75 0 0 1 0 1.5h-.964a2 2 0 0 1-3.71 0H3.5a.75.75 0 0 1 0-1.5zm1.855-.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgParsingSettings;
